<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-numeric-input [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                            (focussed$)="onFocussed($event)" *ngSwitchDefault [notation]="notation" [decimals]="decimals"
                            [showClear]="showClear"
                            [placeholder]="placeholder">
    </fui-edit-numeric-input>
    <fui-filter-numeric-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value" [decimals]="decimals"
                              [placeholder]="placeholder" (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.FILTER">
    </fui-filter-numeric-input>
    <fui-inline-numeric-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                              (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE" [notation]="notation"
                              [decimals]="decimals" [placeholder]="placeholder">
    </fui-inline-numeric-input>
    <fui-header-numeric-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                              (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.HEADER" [notation]="notation"
                              [decimals]="decimals" [placeholder]="placeholder">
    </fui-header-numeric-input>
    <fui-numeric-pill [control]="control" [disabled]="disabled" [label]="label" #input [(ngModel)]="value"
                      [removable]="removable" (removed$)="remove()" [placeholder]="placeholder"
                      (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.PILL" [decimals]="decimals">
    </fui-numeric-pill>
</ng-container>
